/** @format */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api.js";

// Centralisation des routes API vidéo
const API_ROUTES = {
  ADD_VIDEO: `/api/video/add_product_video`,
  GET_PRODUCT_VIDEO: `/api/video/get_product_video`,
  UPDATE_VIDEO: `/api/product/video/update`,
};

// Gestion des messages d'erreur
const getErrorMessage = (error) =>
  error.response?.data.message || error.message;

// -------------------- ACTIONS --------------------

// Ajouter une vidéo produit
export const add_product_video = createAsyncThunk(
  "video/add_product_video",
  async (formData, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(API_ROUTES.ADD_VIDEO, formData, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

// Récupérer la vidéo d'un produit
export const get_product_video = createAsyncThunk(
  "video/get_product_video",
  async (productId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(
        `${API_ROUTES.GET_PRODUCT_VIDEO}/${productId}`,
        { withCredentials: true },
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

// Mettre à jour la vidéo d'un produit
export const update_product_video = createAsyncThunk(
  "video/update_product_video",
  async ({ productId, info }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.put(
        `${API_ROUTES.UPDATE_VIDEO}/${productId}`,
        info,
        { withCredentials: true },
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

// -------------------- REDUCER --------------------
export const videoReducer = createSlice({
  name: "video",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
    video: null,
    videos: [],
  },

  reducers: {
    messageClear: (state) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },

  extraReducers: (builder) => {
    builder
      // Add video
      .addCase(add_product_video.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
        state.successMessage = "";
      })
      .addCase(add_product_video.fulfilled, (state, action) => {
        state.loader = false;
        state.successMessage = action.payload.message;
        state.video = action.payload.video;
      })
      .addCase(add_product_video.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload || "Échec ajout vidéo";
      })

      // Get product video
      .addCase(get_product_video.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
        state.successMessage = "";
      })
      .addCase(get_product_video.fulfilled, (state, action) => {
        state.loader = false;
        state.successMessage = action.payload.message;
        state.video = action.payload.video;
      })
      .addCase(get_product_video.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload || "Échec récupération vidéo";
      })

      // Update video
      .addCase(update_product_video.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
        state.successMessage = "";
      })
      .addCase(update_product_video.fulfilled, (state, action) => {
        state.loader = false;
        state.successMessage = action.payload.message;
        state.video = action.payload.video;
      })
      .addCase(update_product_video.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload || "Échec mise à jour vidéo";
      });
  },
});

export const { messageClear } = videoReducer.actions;
export default videoReducer.reducer;
